export var DependencyDirection;
(function (DependencyDirection) {
    DependencyDirection["FINISH_TO_START"] = "finish_to_start";
    DependencyDirection["START_TO_START"] = "start_to_start";
    DependencyDirection["FINISH_TO_FINISH"] = "finish_to_finish";
    DependencyDirection["START_TO_FINISH"] = "start_to_finish";
})(DependencyDirection || (DependencyDirection = {}));
